import { render } from "./AmenityAmountField.vue?vue&type=template&id=a385c618&scoped=true"
import script from "./AmenityAmountField.vue?vue&type=script&lang=js"
export * from "./AmenityAmountField.vue?vue&type=script&lang=js"

import "./AmenityAmountField.vue?vue&type=style&index=0&id=a385c618&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a385c618"]])

export default __exports__